export default __webpack_public_path__ + "static/media/ic_bone_24.2137eb37.svg";